/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardTemplateUpdateRequest
 */
export interface DashboardTemplateUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardTemplateUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardTemplateUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardTemplateUpdateRequest
     */
    requiredLicenseFeatures?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardTemplateUpdateRequest
     */
    global?: boolean;
}

/**
 * Check if a given object implements the DashboardTemplateUpdateRequest interface.
 */
export function instanceOfDashboardTemplateUpdateRequest(value: object): value is DashboardTemplateUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DashboardTemplateUpdateRequestFromJSON(json: any): DashboardTemplateUpdateRequest {
    return DashboardTemplateUpdateRequestFromJSONTyped(json, false);
}

export function DashboardTemplateUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardTemplateUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'requiredLicenseFeatures': json['requiredLicenseFeatures'] == null ? undefined : json['requiredLicenseFeatures'],
        'global': json['global'] == null ? undefined : json['global'],
    };
}

export function DashboardTemplateUpdateRequestToJSON(json: any): DashboardTemplateUpdateRequest {
    return DashboardTemplateUpdateRequestToJSONTyped(json, false);
}

export function DashboardTemplateUpdateRequestToJSONTyped(value?: DashboardTemplateUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'requiredLicenseFeatures': value['requiredLicenseFeatures'],
        'global': value['global'],
    };
}

